import React from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import HeroSection from "../components/home/HeroSection";
import QuoteForm from "../components/home/QuoteForm";
import ClientsSection from "../components/home/ClientsSection";
import AboutSection from "../components/home/AboutSection";
import ServicesSection from "../components/home/ServicesSection";
import DiscussionSection from "../components/home/DiscussionSection";
import ProjectsSection from "../components/home/ProjectsSection";
import TestimonialsSection from "../components/home/TestimonialsSection";
import MapSection from "../components/home/MapSection";
import OptimizeSection from "../components/home/OptimizeSection";
import CompareQualitySection from "../components/home/CompareQualitySection";
import ModelsSection from "../components/home/ModelsSection";
import OnboardingSection from "../components/home/OnboardingSection";
import BestArchitectureSection from "../components/home/BestArchitectureSection";
import DesireTechSection from "../components/home/DesireTechSection";
import IndustriesSection from "../components/home/IndustriesSection";
import SoftwaresSection from "../components/home/SoftwaresSection";
import AwardsSection from "../components/home/AwardsSection";
import FAQSection from "../components/home/FAQSection";
import BlogsSection from "../components/home/BlogsSection";
import ContactSection from "../components/home/ContactSection";

const Home = () => {
  return (
    <div className="home-page">
      <HeroSection />
      <QuoteForm customStyle={{ marginTop: '-65px' }} />
      <ClientsSection />
      <AboutSection />
      <ServicesSection />
      <DiscussionSection />
      <ProjectsSection />
      <TestimonialsSection />
      <MapSection />
      <OptimizeSection />
      <CompareQualitySection />
      <ModelsSection />
      <OnboardingSection />
      <BestArchitectureSection />
      <DesireTechSection />
      <IndustriesSection />
      <SoftwaresSection />
      <AwardsSection />
      <FAQSection />
      <BlogsSection />
      <ContactSection />
    </div>
  );
};

export default Home;
